import { Pagination } from 'src/lib/interfaces/Pagination.interface'
import { Termination } from '../../lib/interfaces/Termination.interface'

import {
  actionTypes,
  ActionTypes,
  TerminationFetchSuccessAction,
  TerminationConfirmSuccessAction,
  TerminationFetchListSuccessAction
} from './actions'

export interface TerminationState {
  readonly isLoading: boolean
  readonly isCreating: boolean
  readonly isFetching: boolean
  readonly terminations?: Termination[]
  readonly isDeletingTermination: boolean
  readonly terminationDetails?: Termination
  readonly pagination?: Pagination<Termination>
}

export const initialState: TerminationState = {
  isLoading: false,
  isCreating: false,
  isFetching: false,
  terminations: undefined,
  isDeletingTermination: false,
  terminationDetails: undefined
}

export function reducer(state: TerminationState = initialState, action: ActionTypes): TerminationState {
  switch (action.type) {
    case actionTypes.TERMINATIONS_FETCH_LIST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.TERMINATIONS_FETCH_LIST_SUCCESS: {
      const paginatedResponse = (action as TerminationFetchListSuccessAction).payload.terminationListResponse

      return {
        ...state,
        isFetching: false,
        terminations: [
          ...(state.terminations || []),
          ...paginatedResponse.content
        ],
        pagination: paginatedResponse
      }
    }

    case actionTypes.TERMINATIONS_FETCH_LIST_FAILED:
      return {
        ...state,
        isFetching: false
    }

    case actionTypes.TERMINATIONS_RESET_LIST:
      return {
        ...state,
        terminations: undefined
      }

    case actionTypes.TERMINATIONS_FETCH:
      return { ...state, isFetching: true }

    case actionTypes.TERMINATIONS_FETCH_FAILED:
      return { ...state, isFetching: false }

    case actionTypes.TERMINATIONS_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        terminationDetails: (action as TerminationFetchSuccessAction).payload.termination
      }

    case actionTypes.TERMINATIONS_CREATE:
      return {
        ...state,
        isCreating: true
      }

    case actionTypes.TERMINATIONS_CREATE_FAILED:
      return {
        ...state,
        isCreating: false
      }

    case actionTypes.TERMINATIONS_CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false
      }

    case actionTypes.TERMINATIONS_CONFIRM:
      return { ...state, isLoading: true }

    case actionTypes.TERMINATIONS_CONFIRM_FAILED:
      return { ...state, isLoading: false }

    case actionTypes.TERMINATIONS_CONFIRM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        terminationDetails: (action as TerminationConfirmSuccessAction).payload.termination
      }

    case actionTypes.TERMINATIONS_DELETE:
      return { ...state, isDeletingTermination: true }

    case actionTypes.TERMINATIONS_DELETE_FAILED:
      return { ...state, isDeletingTermination: false }

    case actionTypes.TERMINATIONS_DELETE_SUCCESS:
      return { ...state, isDeletingTermination: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/terminations/reducer.ts